import type { Situacion } from '@/lib/personal';

/**
 * De alta / de baja, con el mismo verde y gris que el estado de un propietario.
 * Está extraído porque aparece en la Plantilla, en la ficha y en las dos vistas
 * mensuales, y tenerlo copiado cuatro veces acabaría con cuatro tonos distintos.
 */
export default function SituacionBadge({ situacion, pequeno }: { situacion: Situacion; pequeno?: boolean }) {
  const deAlta = situacion === 'alta';
  return (
    <span
      className={`badge flex-shrink-0 ${pequeno ? 'text-[10px]' : ''} ${
        deAlta ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'
      }`}
    >
      {deAlta ? 'De alta' : 'De baja'}
    </span>
  );
}
